"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
let TrialsBarchart = class TrialsBarchart extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get typology() {
        const typologies = {
            e: { class: 'bullet-positive-effect', type: this.$trans('summary.maa.legend.positive_effect_abr'), stars: '**' },
            t: { class: 'bullet-positive-trend', type: this.$trans('summary.maa.legend.positive_trend_abr'), stars: '*' },
            m: { class: 'bullet-major-change', type: this.$trans('summary.maa.legend.major_change_abr') },
            nt: { class: 'bullet-adverse-trend', type: this.$trans('summary.maa.legend.adverse_trend_abr'), stars: '*' },
            ne: { class: 'bullet-adverse-effect', type: this.$trans('summary.maa.legend.adverse_effect_abr'), stars: '**' },
        };
        return typologies[this.claimType] || null;
    }
    cureValue() {
        let curatedValue = {
            num: 0,
            str: ''
        };
        curatedValue.num = this.value;
        curatedValue.str = curatedValue.num.toFixed(1).toString() + '%';
        return curatedValue;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TrialsBarchart.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], TrialsBarchart.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TrialsBarchart.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '-' })
], TrialsBarchart.prototype, "claimType", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], TrialsBarchart.prototype, "isRelevant", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], TrialsBarchart.prototype, "isSignificant", void 0);
TrialsBarchart = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {},
    })
], TrialsBarchart);
exports.default = TrialsBarchart;
